import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
    Box,
    Typography,
    CircularProgress,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    AppBar,
    Toolbar,
    TextField,
    IconButton,
    // Pagination, // Removendo a importação de Pagination
    ListItemButton,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { searchGames } from '../../utils/sanityQueries';
import { urlFor } from '../../client';
import Navbar from '../../components/Navbar';

const Search = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [tempSearchTerm, setTempSearchTerm] = useState('');
    const [totalResults, setTotalResults] = useState(0); // Não usaremos para paginação agora
    // const [currentPage, setCurrentPage] = useState(1); // Removendo o estado da página
    // const resultsPerPage = 10; // Removendo o limite por página
    // const totalPages = Math.ceil(totalResults / resultsPerPage); // Removendo o cálculo de páginas

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const query = queryParams.get('query');

        if (query) {
            setSearchTerm(query);
            setTempSearchTerm(query);
            const fetchResults = async () => {
                setLoading(true);
                const results = await searchGames(query); // Chamando searchGames sem parâmetros de página e limite
                setSearchResults(results);
                setTotalResults(results.length); // Atualizando o total de resultados
                setLoading(false);
            };
            fetchResults();
        } else {
            setSearchTerm('');
            setTempSearchTerm('');
            setSearchResults([]);
            setTotalResults(0);
            setLoading(false);
            // setCurrentPage(1); // Removendo a atualização da página
        }
    }, [location.search]);

    const handleTempSearchChange = (event) => {
        setTempSearchTerm(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const trimmedSearchTerm = tempSearchTerm.trim();
        if (trimmedSearchTerm) {
            navigate(`/pesquisar?query=${encodeURIComponent(trimmedSearchTerm)}`);
            // setCurrentPage(1); // Removendo a atualização da página
        } else if (searchTerm) {
            navigate('/pesquisar');
            setSearchTerm('');
            setSearchResults([]);
            setTotalResults(0);
            // setCurrentPage(1); // Removendo a atualização da página
            console.log(totalResults)
        }
    };

    // const handleChangePage = (event, value) => { // Removendo a função de mudança de página
    //     setCurrentPage(value);
    //     window.scrollTo(0, 0);
    // };

    return (
        <>
        <Box sx={{ pb: 14 }}>
            <AppBar
                position="sticky"
                color="transparent"
                elevation={1}
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    bgcolor: '#121212',
                }}
            >
                <Toolbar
                    sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: 'center',
                        px: [2],
                        pt: 2,
                        pb: 1,
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            cursor: 'default',
                            width: { xs: '100%', sm: 'auto' },
                            mb: { sm: 0 },
                            lineHeight: 1,
                            flexGrow: { sm: 1 },
                        }}
                    >
                        {searchTerm ? `Buscar: "${searchTerm}"` : 'Pesquisar Jogos'}
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSearchSubmit}
                        noValidate
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            mt: { xs: 2, sm: 0 },
                        }}
                    >
                        <TextField
                            placeholder="Buscar Jogo"
                            variant="outlined"
                            size="small"
                            fullWidth={{ xs: true, sm: false }}
                            value={tempSearchTerm}
                            onChange={handleTempSearchChange}
                            sx={{ mr: 1, width: '100%' }}
                        />
                        <IconButton type="submit" aria-label="buscar">
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box sx={{ position: 'relative', minHeight: '60vh', mt: 2, p: 2 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                        <CircularProgress />
                    </Box>
                ) : searchResults.length > 0 ? (
                    <List sx={{ width: '100%', pt: 0 }}>
                        {searchResults.map((game) => (
                            <ListItem key={game._id} disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to={`/${game.core}/${game.slug?.current}`}
                                    alignItems="center"
                                    sx={{
                                        '&:hover': {
                                            bgcolor: 'rgba(255, 255, 255, 0.08)',
                                        },
                                        mb: 1,
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        px: 2,
                                    }}
                                >
                                    {game.box?.asset?.url && (
                                        <ListItemAvatar sx={{ m: 'auto' }}>
                                            <Avatar
                                                src={urlFor(game.box).width(256).url()}
                                                alt={game.name}
                                                sx={{ width: { xs: 96, sm: 128 }, height: 'auto', borderRadius: 1, mr: 2 }}
                                            />
                                        </ListItemAvatar>
                                    )}
                                    <ListItemText
                                        primary={game.name}
                                        sx={{
                                            '.MuiTypography-root': {
                                                fontSize: { xs: '1rem', sm: '1.25rem' },
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            },
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                ) : searchTerm.length >= 3 && !loading ? (
                    <Typography variant="subtitle1" align="center" sx={{ mt: 2 }}>
                        Nenhum jogo encontrado para "{searchTerm}"
                    </Typography>
                ) : !loading && location.search && !searchTerm ? (
                    <Typography variant="subtitle1" align="center" sx={{ mt: 2 }}>
                        Digite um termo para buscar jogos.
                    </Typography>
                ) : !loading && !location.search ? (
                    <Typography variant="subtitle1" align="center" sx={{ mt: 2 }}>
                        Digite um termo para iniciar a busca.
                    </Typography>
                ) : null}

                {/* Removendo o componente Pagination */}
                {/* {totalResults > resultsPerPage && searchResults.length > 0 && !loading && (
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        variant="text"
                        color="primary"
                        onChange={handleChangePage}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 2,
                        }}
                    />
                )} */}
            </Box>
        </Box>
        <Navbar />
        </>
    );
};

export default Search;